import { useQuery } from 'react-query';
import feathersClient from '../../apiClient';

interface UseAdminPopupsQueryParams {
  search: string;
  pageNum: number;
  pageSizeNum: number;
  sort: Record<string, number>;
}

export function useAdminPopupsQuery({ search, pageNum, pageSizeNum, sort }: UseAdminPopupsQueryParams) {
  return useQuery(
    ['admin-popup', search, pageNum, pageSizeNum, sort],
    () =>
      feathersClient.service('admin-popup').find({
        query: {
          $skip: (pageNum - 1) * pageSizeNum,
          $limit: pageSizeNum,
          $sort: sort,
          ...(search && {
            $or: [{ content: { $ilike: `%${search}%` } }, { name: { $ilike: `%${search}%` } }],
          }),
        },
      }),
    { keepPreviousData: true }
  );
}

export const listAdminPopupHeaders = [
  { value: 'name', label: 'Název', sortable: true },
  { value: 'headline', label: 'Obsah', sortable: true },
  { value: 'from', label: 'Od', sortable: true },
  { value: 'to', label: 'Do', sortable: true },
  { value: 'created_at', label: 'Vytvořeno', sortable: true },
  { value: 'state', label: 'Stav', sortable: false },
  { value: 'actions', label: 'Akce', sortable: false },
];
